import type { MaxIds, UpdateMaxIdsAction } from './types';
import { MaxIdsEnum } from './types';

export function maxIdsReducer(
  state: MaxIds,
  action: UpdateMaxIdsAction
): MaxIds {
  switch (action.type) {
    case MaxIdsEnum.updateMaxIds:
      return {
        ...state,
        [action.payload.type]: action.payload.value
      };
    default:
      return state;
  }
}
